import axios from 'axios';
import { SETTINGS } from '../../config/settings';

const baseURL = SETTINGS.public.basePath;

const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
